require("stylesheets/application.scss")

// import * as ActionCable from '@rails/actioncable';
// window.Cable = ActionCable.createConsumer();

import * as ActiveStorage from '@rails/activestorage';
ActiveStorage.start();

import Rails from '@rails/ujs';
Rails.start();

import "controllers"

require("trix")
require("@rails/actiontext")
